import { useMemo, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { cn } from "@/lib/utils";

export default function ClienteBusquedaSelect({
  clientes = [],
  onSelect,
  yaEnRuta = new Set(),
  placeholder = "Buscar cliente por nombre…",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  const filtrados = useMemo(() => {
    const t = q.trim().toLowerCase();
    const list = clientes || [];
    if (!t) return list;
    return list.filter((c) => {
      const hay = [c.nombre, c.codigo, c.poblacion, c.provincia, c.direccion]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(t);
    });
  }, [clientes, q]);

  return (
    <Popover modal open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className="h-10 w-full justify-between font-normal text-zinc-600"
        >
          <span className="truncate">{placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput
            placeholder="Escribe para filtrar…"
            value={q}
            onValueChange={setQ}
          />
          <CommandList>
            <CommandEmpty>Ningún cliente coincide.</CommandEmpty>
            <CommandGroup>
              {filtrados.map((c) => {
                const id = String(c.id);
                const veces = typeof yaEnRuta.get === "function" ? yaEnRuta.get(id) || 0 : 0;
                const marcado = veces > 0 || (yaEnRuta instanceof Set && yaEnRuta.has(id));
                return (
                  <CommandItem
                    key={c.id}
                    value={`${c.nombre} ${c.id}`}
                    className={cn(marcado && "bg-sky-50 text-sky-900")}
                    onSelect={() => {
                      onSelect?.(c);
                      setOpen(false);
                      setQ("");
                    }}
                  >
                    <Check className={cn("mr-2 h-4 w-4", marcado ? "opacity-100" : "opacity-0")} />
                    <span className="min-w-0 flex-1 truncate">
                      {c.nombre}
                      {c.poblacion ? ` · ${c.poblacion}` : ""}
                      {c.es_potencial ? " · potencial" : ""}
                      {veces > 0 ? ` · ya en ruta${veces > 1 ? ` (${veces})` : ""}` : ""}
                    </span>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
